/* eslint-disable @typescript-eslint/no-explicit-any */
import request from 'utils/request';

const profitAndLostService = {
  getList: (params: any) => request.get('/report/profit-loss', { params })
};

export default profitAndLostService;
